module.exports = __webpack_public_path__ + "img/ISL.4aecea93.svg";